import React from "react";

const Bath = ({
  width = 28,
  height = 40,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1316_30033)">
        <path
          d="M6.5 20.9022C6.5 20.8383 6.5 20.8063 6.50176 20.7793C6.52891 20.3616 6.86162 20.0289 7.27926 20.0018C7.30627 20 7.33826 20 7.40223 20H20.5978C20.6617 20 20.6937 20 20.7207 20.0018C21.1384 20.0289 21.4711 20.3616 21.4982 20.7793C21.5 20.8063 21.5 20.8383 21.5 20.9022C21.5 21.232 21.5 21.3968 21.4883 21.5814C21.3144 24.3212 18.9858 26.7389 16.2544 27.0155C16.0705 27.0342 15.9631 27.0382 15.7485 27.0463C15.1367 27.0693 14.5411 27.0833 14 27.0833C13.4589 27.0833 12.8633 27.0693 12.2515 27.0463C12.0369 27.0382 11.9295 27.0342 11.7456 27.0155C9.01421 26.7389 6.6856 24.3212 6.51171 21.5814C6.5 21.3968 6.5 21.232 6.5 20.9022Z"
          stroke="#868C98"
          strokeWidth="1.5"
        />
        <path
          d="M9.00033 26.666L8.16699 28.3327"
          stroke="#868C98"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M18.9997 26.666L19.833 28.3327"
          stroke="#868C98"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M5.66699 20H22.3337"
          stroke="#868C98"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M5.75 20.8327C5.75 21.2469 6.08579 21.5827 6.5 21.5827C6.91421 21.5827 7.25 21.2469 7.25 20.8327H5.75ZM10.3331 12.9155L11.0295 12.6369L11.0295 12.6369L10.3331 12.9155ZM10.649 13.7053L10.9773 14.3796L10.649 13.7053ZM9.30176 15.1596L9.99665 15.4418L9.30176 15.1596ZM12.8142 13.6475L12.5195 14.3372L12.8142 13.6475ZM9.28799 17.284L8.59021 17.5589C8.66461 17.7478 8.81238 17.8984 8.99975 17.9764C9.18713 18.0544 9.39812 18.0531 9.58455 17.9729L9.28799 17.284ZM14.2553 15.1456L14.5518 15.8345C14.9239 15.6743 15.1016 15.2475 14.9531 14.8706L14.2553 15.1456ZM7.25 20.8327V13.6537H5.75V20.8327H7.25ZM8.48764 12.416C8.99371 12.416 9.4488 12.7241 9.63675 13.194L11.0295 12.6369C10.6137 11.5976 9.60707 10.916 8.48764 10.916V12.416ZM7.25 13.6537C7.25 12.9701 7.80411 12.416 8.48764 12.416V10.916C6.97568 10.916 5.75 12.1417 5.75 13.6537H7.25ZM9.63675 13.194L9.95269 13.9838L11.3454 13.4268L11.0295 12.6369L9.63675 13.194ZM9.98577 17.009C9.79574 16.5267 9.78361 15.9664 9.99665 15.4418L8.60688 14.8774C8.24414 15.7707 8.26365 16.7302 8.59021 17.5589L9.98577 17.009ZM13.9587 14.4567L8.99143 16.5951L9.58455 17.9729L14.5518 15.8345L13.9587 14.4567ZM12.5195 14.3372C13.0047 14.5445 13.3676 14.9386 13.5575 15.4205L14.9531 14.8706C14.6264 14.0415 13.9877 13.3333 13.1088 12.9578L12.5195 14.3372ZM9.99665 15.4418C10.1967 14.9492 10.5556 14.5849 10.9773 14.3796L10.3208 13.031C9.57074 13.3961 8.94805 14.0373 8.60688 14.8774L9.99665 15.4418ZM10.9773 14.3796C11.4526 14.1483 12.0068 14.1182 12.5195 14.3372L13.1088 12.9578C12.1756 12.5592 11.1668 12.6191 10.3208 13.031L10.9773 14.3796Z"
          fill="#868C98"
        />
      </g>
      <defs>
        <clipPath id="clip0_1316_30033">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(4 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Bath;
